// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"60093e9d","703":"c092cc72","787":"7aeee684"}[chunkId] + ".chunk.js";
};